var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167559 5.88144C-0.0558534 6.10485 -0.0558534 6.46597 0.167559 6.68938C0.390972 6.91279 0.752089 6.91279 0.975502 6.68938L3.83244 3.83244C4.05585 3.60903 4.05585 3.24791 3.83244 3.0245L0.975502 0.167559C0.752089 -0.0558532 0.390972 -0.0558532 0.167559 0.167559C-0.0558534 0.390972 -0.0558534 0.752089 0.167559 0.975502L2.62053 3.42847L0.167559 5.88144Z",
    fill: "#292F49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6d4e58b6a8576534b50fccadca4ee5aa.svg";
export { ForwardRef as ReactComponent };